"use client";

import { translateMessage } from "@/lib/toast";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useLocale } from "next-intl";

/* inline status banner (forms) — localized through the same
   dictionary the toasts use, styled to match them */
export default function ErrorHandling({ messages, type }: { messages: any; type?: "error" | "success" | "" }) {
  const locale = useLocale() === "en" ? "en" : "ar";
  const ar = locale === "ar";
  const text = translateMessage(messages, locale);
  if (!text) return null;
  const err = type === "error";
  const accent = err ? "#e5484d" : "#2fb67c";

  return (
    <div dir={ar ? "rtl" : "ltr"} className="flex w-full max-w-xl select-none justify-center py-4" role="status">
      <div
        className="sna-toast relative flex w-full items-center gap-3.5 overflow-hidden rounded-2xl px-4 py-3.5 text-white"
        style={{
          background: "linear-gradient(135deg,#0f2f7a 0%,#0a1e4f 55%,#071535 100%)",
          boxShadow: `0 22px 50px -22px rgba(7,21,53,0.7), 0 0 0 1px rgba(255,255,255,0.06) inset`,
        }}
      >
        <span className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#d9b25a]/80 to-transparent" />
        <span className={`absolute inset-y-2 ${ar ? "right-0" : "left-0"} w-1 rounded-full`} style={{ background: accent }} />
        <span
          className="grid size-10 shrink-0 place-items-center rounded-xl"
          style={{ background: `${accent}22`, color: accent, boxShadow: `0 0 0 1px ${accent}55 inset` }}
        >
          {err ? <AlertTriangle size={20} strokeWidth={2.4} /> : <CheckCircle2 size={20} strokeWidth={2.4} />}
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-black uppercase tracking-[0.18em]" style={{ color: accent }}>
            {err ? (ar ? "تنبيه" : "Error") : ar ? "تم بنجاح" : "Success"}
          </p>
          <p className="mt-0.5 text-sm font-bold leading-snug text-white/95">{text}</p>
        </div>
      </div>
    </div>
  );
}
